import { authClient } from "@/lib/auth-client"

export const useAuthLoader = async () => {
    try {
        const session = await authClient.getSession() 
        return session.data
    } catch (error) {
        throw error
    }
}